import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    width: 350,
    justifyContent: "space-between",
    padding: 16,
    alignSelf: "center",
    flex: 1,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    alignItems: "center",
    marginBottom: 12,
  },

  containerPasswd: {
    marginTop: 30,
    alignSelf: "center",
    textAlign: "center",
  },

  modal: {
    margin: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  modalContainer: {
    flex: 1,
    padding: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  modalClose: {
    position: "absolute",
    top: 16,
    left: 16,
  },
  modalSuccess: {
    width: 80,
    height: 80,
    marginBottom: 32,
  },
  modalText: {
    textAlign: "center",
    marginBottom: 16,
  },
  modalImage: {
    position: "absolute",
    width: 120,
    height: 120,
    right: 0,
    top: "80%",
  },
  textBold: {
    fontWeight: "bold",
  },
  copyText: {
    fontWeight: "bold",
    color: "green",
  },

  btnCancelar: {
    fontFamily: "Poppins, sans-serif",
    padding: 4,
    width: 120,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    alignSelf: "center",
    color: "#077A97",
    textTransform: "uppercase",
    flexWrap: "wrap",
    marginRight: 10,
  },

  btnConfimeSaque: {
    fontFamily: "Poppins, sans-serif",
    padding: 4,
    width: 120,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    alignSelf: "center",
    color: "#fff",
    textTransform: "uppercase",
    flexWrap: "wrap",
  },

  cardTitleTxt: {
    fontWeight: "bold",
    fontSize: 18,
    color: "#077A97",
    textAlign: "center",
  },

  containerBtns: {
    marginTop: 60,
    justifyContent: "space-between",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    alignSelf: "center",
  },
});
